import lfRequest from '@/service/index'
export function statisticDay(fillDates?: [], deptId?: number, empIds?: []) {
  return lfRequest.get<any>({
    url: '/main/dailyCust/statistic/day',
    params: {fillDates, deptId, empIds}
  })
}
